const queue = new Set<() => void>();

export function add(task: () => void): () => void {
	queue.add(task);
	if (queue.size === 1) {
		requestAnimationFrame(() => {
			for (const task of queue) {
				task();
			}
			queue.clear();
		});
	}
	return task;
}

export function remove(task: () => void): void {
	queue.delete(task);
}
